module.exports = __webpack_public_path__ + "media/assets/icons/deleteWhite-746771d84ee7b266636fd16fde7c5da7.svg";